import { render, staticRenderFns } from "./IndexHandle.vue?vue&type=template&id=1e1deab6&scoped=true"
import script from "./IndexHandle.vue?vue&type=script&lang=js"
export * from "./IndexHandle.vue?vue&type=script&lang=js"
import style0 from "./IndexHandle.vue?vue&type=style&index=0&id=1e1deab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1deab6",
  null
  
)

export default component.exports